import { rootApi } from '../../../store/rootApi.js'
import type { Dashboard } from '../core/types.js'

/**
 * 9.1's one request.
 *
 * Injected onto the root api rather than creating one: a second `createApi` is a
 * second cache, and two caches mean a mutation on one screen leaves the other
 * showing yesterday's figure.
 *
 * The whole screen is one call on purpose. The figures, the week, the attention
 * panel and the two recent lists are one answer about one moment — fetching them
 * separately would let the Bookings figure and the recent bookings below it
 * disagree, which is exactly the sort of thing somebody notices and nobody can
 * explain.
 */
export const overviewApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getDashboard: build.query<Dashboard, void>({
      query: () => ({ url: '/v1/admin/dashboard', method: 'GET' }),
      /**
       * One tag, because there is one thing here: today.
       *
       * Anything that changes a figure on this screen — a refund, a provider
       * going live, an invitation resent — invalidates `Dashboard`, and the
       * screen refetches the lot. Tagging the parts separately would be a lie
       * about a response that cannot be partly stale.
       */
      providesTags: [{ type: 'Dashboard', id: 'TODAY' }],
    }),
  }),
})

export const { useGetDashboardQuery } = overviewApi
